import { useMemo } from 'react'
import { startOfDay } from 'date-fns'
import { slugs } from '@/constants/slugs'

interface LimitedEventConfig {
  slug: string
  eventDate: Date
}

const LIMITED_EVENT_CONFIGS: LimitedEventConfig[] = [
  {
    slug: slugs.senior,
    eventDate: startOfDay(new Date(2025, 8, 8)),
  },
  {
    slug: slugs.truthAndTreason,
    eventDate: startOfDay(new Date(2025, 9, 6)),
  },
  {
    slug: slugs.david,
    eventDate: startOfDay(new Date(2025, 11, 8)),
  },
  {
    slug: slugs.soloMio,
    eventDate: startOfDay(new Date(2026, 0, 20)),
  },
]

export const useShouldShowLimitedEvent = (theatricalSlug?: string) => {
  return useMemo(() => {
    if (!theatricalSlug) return { shouldShow: false, eventDate: null, hasLimitedEvent: false }

    const config = LIMITED_EVENT_CONFIGS.find(({ slug }) => slug === theatricalSlug)
    if (!config) return { shouldShow: false, eventDate: null, hasLimitedEvent: false }

    const shouldShow = config.eventDate >= startOfDay(new Date())

    return {
      shouldShow,
      eventDate: config.eventDate,
      hasLimitedEvent: true,
    }
  }, [theatricalSlug])
}
